/**
 * Cookie utility functions for handling browser cookies
 */

/**
 * Sets a cookie with the given name, value, and optional parameters
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {number} days - Number of days until cookie expires (default: 30)
 * @param {string} path - The path for the cookie (default: '/')
 */
export function setCookie(name, value, days = 30, path = '/') {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=${path};SameSite=Lax`;
}

/**
 * Gets the value of a cookie by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

/**
 * Deletes a cookie by name
 * @param {string} name - The name of the cookie to delete
 * @param {string} path - The path for the cookie (default: '/')
 */
export function deleteCookie(name, path = '/') {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};`;
}

/**
 * Checks if a cookie exists
 * @param {string} name - The name of the cookie to check
 * @returns {boolean} True if cookie exists, false otherwise
 */
export function cookieExists(name) {
  return getCookie(name) !== null;
} 